import React from "react"
import SEO from "../components/SEO"
import PageIllustration from "../partials/PageIllustration"
import BlogList from "../components/BlogList"
import CalendlyBook from "../partials/CalendlyBook"
import { graphql } from "gatsby"

function Tag({ data, pageContext }) {
  return (
    <>
      <SEO {...{ ghostData: data.ghostTag, pageType: "blogByTag" }} />
      {/*  Page content */}
      <main className="flex-grow">
        {/*  Page illustration */}
        <div
          className="relative max-w-6xl mx-auto h-0 pointer-events-none"
          aria-hidden="true"
        >
          <PageIllustration />
        </div>

        {/*  Page sections */}
        <BlogList {...{ data, pageType: "blogByTag", pageContext }} />
        <CalendlyBook />
      </main>
    </>
  )
}

export default Tag

export const pageQuery = graphql`
  query GhostTagQuery($slug: String!, $limit: Int!, $skip: Int!) {
    ghostTag(slug: { eq: $slug }) {
      ...GhostTagFields
    }
    allGhostPost(
      sort: { published_at: DESC }
      filter: { tags: { elemMatch: { slug: { eq: $slug } } } }
      limit: $limit
      skip: $skip
    ) {
      edges {
        node {
          ...GhostPostFields
          featureImage {
            childImageSharp {
              gatsbyImageData(
                width: 540
                height: 303
                quality: 50
                formats: [AUTO, WEBP]
              )
            }
          }
          profileImage {
            childImageSharp {
              gatsbyImageData(
                width: 40
                height: 40
                quality: 90
                formats: [AUTO, WEBP]
              )
            }
          }
        }
      }
    }
  }
`
